/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

const HeaderLocationsMenu: React.FC<any> = (clickCapture) => {
  const navigate = useNavigate()
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({ id }, values)

  interface columnItem {
    id: number
    nasname: string
    shortname: string
    description?: string
    expire?: any
    is_expire?: boolean // API'den gelen is_expire flag'i için
    type?: string | number // 2 ise Ruijie cihaz
  }

  const storedData = localStorage.getItem('kt-auth-react-v')
  const [columnItems, setColumnItems] = useState<columnItem[]>([])

  useEffect(() => {
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData)
        setColumnItems(parsedData.data.locations)
      } catch (error) {
        console.error('LocalStorage verisi işlenirken hata oluştu:', error)
      }
    }
  }, [storedData])

  const [filter, setFilter] = useState<string>('')

  // 🔽 FİLTRELEME VE SIRALAMA MANTIĞI 🔽
  const filteredItems = columnItems
    .filter(
      (item) =>
        item.shortname.toLowerCase().includes(filter.toLowerCase()) ||
        item.nasname.toLowerCase().includes(filter.toLowerCase()) ||
        (item.description && item.description.toLowerCase().includes(filter.toLowerCase()))
    )
    .sort((a, b) => {
      // is_expire veya tarih karşılaştırması üzerinden durum belirleme
      const aExpired = a.is_expire ?? new Date(a.expire) < new Date()
      const bExpired = b.is_expire ?? new Date(b.expire) < new Date()

      if (aExpired === bExpired) return 0
      return aExpired ? 1 : -1 // Geçenler (true) sona, geçmeyenler (false) başa
    })

  const handleClick = (item: {}) => {
    localStorage.setItem('selectedLocation', JSON.stringify(item))
    navigate(0)
  }

  const inputRef = useRef<HTMLInputElement | null>(null)
  useEffect(() => {
    if (inputRef.current !== null) {
      inputRef.current.focus()
    }
  }, [clickCapture])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-100 w-md-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div className='d-flex flex-column bg-info rounded-top cursor-default px-12'>
        <h3 className='text-white fw-bold mt-10 mb-6'>{t('change_location')}</h3>
        <input
          ref={inputRef}
          type='text'
          className='form-control form-control-solid mb-4'
          placeholder={t('search')}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>

      <div className='tab-content'>
        <div className='tab'>
          <div className='scroll-y mh-325px my-5 px-4'>
            {filteredItems.map((item) => {
              // Süre kontrolünü burada bir değişkene atayalım
              const isExpired = item.is_expire ?? new Date(item.expire) < new Date()
              const isRuijie = String(item.type) === '2'

              return (
                <div key={item.id}>
                  <div
                    onClick={() => handleClick(item)}
                    className={`d-flex row p-4 bg-hover-light rounded cursor-pointer ${isExpired ? 'bg-secondary bg-opacity-25 opacity-75' : ''
                      }`}
                    style={{
                      borderLeft: isExpired ? 'none' : '4px solid #009ef7',
                      marginBottom: '2px',
                    }}
                  >
                    <div className='d-flex w-100 justify-content-between align-items-center'>
                      <h4 className={`fs-6 fw-bolder mb-0 ${isExpired ? 'text-gray-500' : 'text-gray-800'}`}>
                        {item.shortname}
                        {isRuijie && (
                          <span className='badge badge-warning text-dark fs-9 ms-4 align-middle'>
                            Ruijie
                          </span>
                        )}
                      </h4>
                      <span className={`badge ${isExpired ? 'badge-secondary' : 'badge-light-primary'} fs-7`}>
                        {item.nasname}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mt-1'>
                      <div className='text-gray-400 fs-7'>{item.description}</div>
                      {isExpired && (
                        <span className='text-danger fs-9 fw-bold text-uppercase'>
                          {t('expired')}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className='separator border-gray-200 mt-1'></div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export { HeaderLocationsMenu }